export const css = {
	oneaction: '_1DwVj1MC',
	primaryButton: '_3bz7pzez',
	' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/questionfeedback'
};

export default css;
